export default function menuDropdown() {
    // isMobile = window.matchMedia('only screen and (max-width: 1023px)').matches;

    const menuItem = jQuery('.menu-item-has-children > a');
    const subMenu = '.sub-menu';
    const closeBtn = jQuery('#closeBtn');

    menuItem.on('click', function () {
        jQuery('.menu-item-has-children').removeClass('!bg-transparent !shadow-none');
        jQuery(this).closest('.menu-item-has-children').addClass('!bg-transparent !shadow-none');
        let clickedSubMenu = jQuery(this).parent().find(subMenu);
        jQuery(subMenu).not(clickedSubMenu).removeClass('show');
        clickedSubMenu.stop().toggleClass('show');
    });

    closeBtn.on('click', function () {
        jQuery('.menu-item-has-children').removeClass('!bg-transparent !shadow-none');
        jQuery(subMenu).removeClass('show');
    });
}
